"use strict";

require('./bootstrap');
require('./components/geolocation');
require('./components/header');
require('./components/lazysizes');
// require('./components/color-button');
// require('./components/dropdown-controller');
// require('./components/contato-email');
require('./components/footer');

import Detection from './utils/detection';

window.addEventListener('DOMContentLoaded', () => {
  const detection = new Detection();

  if (document.getElementById('splashscreen')) require('./components/modal/splashscreen');

  //     // Detections
  //     if (detection.isMobile() && detection.isAndroid() && detection.isChrome()) {
  //         document.body.classList.add('is-ua-android');
  //     } else if (detection.isMobile() && detection.isIOS() && detection.isChrome()) {
  //         document.body.classList.add('is-ua-ios');
  //     }
});
